import {BaseObject, IBaseObject} from "./BaseObject";

export interface IAssociationSegment extends IBaseObject {
  idPgm?: number;
  idSegment: number;
  nomSegment: string;
  idsTypeEs: number[];
  descriptionsTypeEs?: string[];
}

export class AssociationSegment extends BaseObject implements IAssociationSegment {
  idPgm?: number;
  idSegment = -1;
  nomSegment = '';
  idsTypeEs: number[] = [];
  descriptionsTypeEs: string[] = [];

  constructor(props?: IAssociationSegment) {
    super(props);

    if (props) {
      this.idPgm = props.idPgm;
      this.idSegment = props.idSegment;
      this.nomSegment = props.nomSegment;
      if (props.idsTypeEs) {
        this.idsTypeEs = [...props.idsTypeEs];
      }
      if (props.descriptionsTypeEs) {
        this.descriptionsTypeEs = [...props.descriptionsTypeEs];
      }
    }
  }

  public format(): IAssociationSegment {
    const item: IAssociationSegment = {
      id: this.id,
      idSegment: this.idSegment,
      idsTypeEs: [...this.idsTypeEs],
      nomSegment: this.nomSegment,
    };

    if (this.idPgm && this.idPgm > -1) {
      item.idPgm = this.idPgm;
    }

    if (item.id == null || item.id === -1) {
      // @ts-ignore
      delete item.id;
    }

    return item;
  }
}
